// extracted by mini-css-extract-plugin
export var banner = "_r1-0";
export var settingRow = "_r1-2";
export var titleIcon = "_r1-1";